import React from "react";
import StreamsDataTable from "./result_stream_dataTable";
import StreamsComponentTable from "./result_stream_component_table";

// 改成接收对比需要的参数
const StreamTabContent = ({ multiResults, materials, transInputs, selectResultPage }) => {
  return (
    <div className="stream-tab-content-container">
      {selectResultPage === "流股工艺数据" ? (
        // 工艺表格：传入多任务对比数据
        <StreamsDataTable
          multiResults={multiResults}
          transInputs={transInputs}
        />
      ) : (
        // 组分表格：传入多任务对比数据 + 物料
        <StreamsComponentTable
          multiResults={multiResults}
          materials={materials.materials}
          transInputs={transInputs}
        />
      )}
    </div>
  );
};

export default StreamTabContent;